import $api from "@/core/services/ApiService";
import { AxiosRequestConfig, AxiosResponse } from "axios";
import { FormType } from "@/core/services/api/interfaces/dict/CreateTransactionPage";
import { TransactionMethod } from "@/core/services/api/enums/TransactionMethod";
import {
  BuyCrypto,
  WithdrawCrypto,
} from "@/core/services/api/interfaces/manager/Crypto";

class GrandTotalEndpoint {
  public [TransactionMethod.CARD](form: FormType): Promise<AxiosResponse> {
    return $api.post("manager/grand-total/card", form as AxiosRequestConfig);
  }

  public [TransactionMethod.CRYPTO](form: FormType): Promise<AxiosResponse> {
    return $api.post("manager/grand-total/crypto", form as AxiosRequestConfig);
  }

  public [TransactionMethod.IBAN](form: FormType): Promise<AxiosResponse> {
    return $api.post("manager/grand-total/iban", form as AxiosRequestConfig);
  }

  public [TransactionMethod.TRANSFER](form: FormType): Promise<AxiosResponse> {
    return $api.post(
      "manager/grand-total/transfer",
      form as AxiosRequestConfig
    );
  }

  public [TransactionMethod.EXCHANGE](form: FormType): Promise<AxiosResponse> {
    return $api.post(
      "manager/grand-total/transfer",
      form as AxiosRequestConfig
    );
  }

  public [TransactionMethod.CONVERT](form: FormType): Promise<AxiosResponse> {
    return $api.post("manager/grand-total/convert", form as AxiosRequestConfig);
  }

  public withdrawCrypto(form: WithdrawCrypto): Promise<AxiosResponse> {
    return $api.post(
      "manager/grand-total/katbit/withdraw-crypto",
      form as AxiosRequestConfig
    );
  }

  public fiatCryptoExchange(form: BuyCrypto): Promise<AxiosResponse> {
    return $api.post(
      "manager/grand-total/katbit/exchange/fiat-crypto",
      form as AxiosRequestConfig
    );
  }
}

export default GrandTotalEndpoint;
